"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TooltipComp;

var _react = _interopRequireDefault(require("react"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _styles = require("@material-ui/core/styles");

var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = (0, _styles.makeStyles)({
  tooltip: {
    fontSize: '1rem',
    backgroundColor: '#474747',
    borderRadius: '4px'
  }
});

function TooltipComp(props) {
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: props.title,
    placement: "bottom",
    classes: {
      tooltip: styles().tooltip
    }
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "tooltipButton"
  }, /*#__PURE__*/_react.default.createElement(_core.SvgIcon, null, /*#__PURE__*/_react.default.createElement(_HelpOutline.default, null))));
}